module.exports = __webpack_public_path__ + "static/media/iet.f9100534.png";